module.exports = ".mat-form-field{font-size:14px;width:100%}\n"